import { render, staticRenderFns } from "./teamprofit.vue?vue&type=template&id=58948f42&scoped=true&"
import script from "./teamprofit.vue?vue&type=script&lang=js&"
export * from "./teamprofit.vue?vue&type=script&lang=js&"
import style0 from "./teamprofit.vue?vue&type=style&index=0&id=58948f42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58948f42",
  null
  
)

export default component.exports